export default {
  0: 'Success',
  1: 'Error',
  2: 'Senvisitive',
  200: 'Success',
  201: 'NoData',
  203: 'HandleDataError',
  211: 'ParameterError',
  502: 'RequestEmpty',
  504: 'ClosedQuestion',
  10002: 'DataError'
}